angular
	.module 'App.Module.PredefinedDiscount', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'predefined_discounts',
				url: '/predefined-discounts'
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@predefined_discounts":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						# Re-use from promotion-campaign
						controller: 'PromotionCampaignSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Promotions'
					searchParams:
						advanced:
							configuration: SEARCH_CONFIGURATION.promotion
						# Re-use from promotion-campaign
						labelTemplate: '@app/promotion-campaign/promotion-campaign.search-label.view.html'
						repositoryName: 'PromotionRepository'
						title: 'menu.predefined.discounts'
						filterEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.PromotionManagement.EnableSearch'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					categories: (ProductCategoryRepository) ->
						return ProductCategoryRepository.getEntities()
					customerGroups: (CustomerGroupRepository) ->
						return CustomerGroupRepository.getEntities()
					promotionTypeIsCampaign: -> false
					productFilters: (ProductFilterRepository) ->
						return ProductFilterRepository.getEntities()

			.state 'predefined_discounts.edit',
				abstract: true
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					discountData: ($stateParams, PromotionCampaignService) ->
						return {} if _.isEmpty $stateParams.id

						return PromotionCampaignService
							.loadDiscount($stateParams.id)
							.then (response) =>
								response.benefit_products = response.benefit_products.filter (item) ->
									item.products != null
								return response
							.catch (response) =>
								console.error(response)

								return {}

					discountBenefitProductCategories: (discountData, PromotionCampaignService) ->
						if discountData.id == null
							return []

						return PromotionCampaignService.loadPromotionBenefitProductCategoriesByCampaignId(discountData.id)

			.state 'predefined_discounts.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'PredefinedDiscountController'
						controllerAs: 'vm'
						templateUrl: '@app/predefined-discount/predefined-discount.view.html'
